<template>
  <div v-if="isAdmin && this.currentWorkspace && this.currentWorkspace.admins">
    <Header />
    <div class="center">
      <div class="pageTitle pageTitle_settings">Settings</div>
      <div class="whiteBox whiteBoxSettings">
        <div class="pageSubTitle">Team</div>
        <div class="profileAvatar" v-bind:style="{ backgroundImage: `url(${logoUrl})` }">
          <div v-if="!logoUrl && currentWorkspace.name" class="profileAvatar_name">
            {{currentWorkspace.name && String(currentWorkspace.name).substring(0,1)}}
          </div>
          <div v-if="loading.image" class="profileAvatar_loader"></div>
          <div v-if="!loading.image" class="profileAvatar_hover">Change</div>
          <input v-if="!loading.image" @change="uploadFile($event.target.files)" type="file" accept="image/*" />
        </div>

        <table class="profile_table">
          <tr>
            <td>Name</td>
            <td>
              {{ currentWorkspace.name }}
            </td>
            <td>
              <button class="button button_cancel" @click="editNameShowPopup">Edit</button>
            </td>
          </tr>
        </table>
      </div>
      <div class="whiteBox whiteBoxSettings team_members">
        <div class="pageSubTitle">
          Members
        </div>
        <button type="button" class="button button_ok" @click="activeModal.unshift('invite')">
          Invite team member
        </button>
        <table>
          <tr>
            <td>
              Name
            </td>
            <td></td>
            <td></td>
          </tr>
          <TeamRow v-for="member of membersPaginated" v-bind:key="member.id" v-bind:member="member" />
        </table>

        <paginate
          :page-count="totalPages"
          v-if="totalPages>1"
          :click-handler="clickPaginationHandle"
          :prev-text="'Prev'"
          :next-text="'Next'"
          prev-class="pagination-prev"
          next-class="pagination-next"
          :container-class="'pagination'">
        </paginate>
      </div>
    </div>
    <div class="popup_shadow" @click="hideFirstModal" v-if="activeModal.length"></div>

    <Popup v-show="activeModal[0] === 'changeName'" title="Edit Team Name">
      <template v-slot:fields>
        <label>Name</label>
        <input
          type="text"
          v-model="newTeamName"
          @keyup="
            () => {
              error.newTeamName = '';
            }
          "
        />
        <div v-if="error.newTeamName !== ''" class="error-msg">
          {{ error.newTeamName }}
        </div>
      </template>

      <template v-slot:buttons>
        <button class="button button_cancel" @click="hideFirstModal()">
          Cancel
        </button>
        <button type="button" v-bind:class="[loading.teamName ? 'loading loading-center' : '', 'button button_ok']" @click="saveNewName">Save changes</button>
      </template>
    </Popup>

    <Popup v-show="activeModal[0] === 'invite'" title="Invite Team Member" subTitle="Team members will have access to all retrospectives for this team.">
      <template v-slot:fields>
        <label>Email address</label>
        <input type="email" v-model="inviteEmail"  @keyup="() => {error.invite = '';}" />
        <div v-if="error.invite !== ''" class="error-msg">
          {{ error.invite }}
        </div>
      </template>
      <template v-slot:buttons>
        <button class="button button_cancel" @click="hideFirstModal">Cancel</button>
        <button v-bind:class="[loading.invite ? 'loading loading-center' : '', 'button button_ok']" @click="sendInvite">Invite</button>
      </template>
    </Popup>
  </div>
</template>

<script>
import Header from '../elements/Header.vue';
import mixins from 'src/mixins.js';
import db, { AUTH, STORAGE, ANALYTICS } from 'src/firebase-config';
import * as firebase from 'firebase';
import { mapState } from 'vuex';
import Popup from '../elements/Popup';
import firebaseFirestore from 'src/firebase-config';
import TeamRow from '../elements/TeamRow';

export default {
  mixins: [mixins],
  components: { TeamRow, Header, Popup },
  data() {
    return {
      currentPage:1,
      linesPerPage:10,
      loading: {
        teamName: false,
        image: false,
        invite: false
      },
      activeModal: [],
      error: {
        newTeamName: '',
        invite: ''
      },
      newTeamName: '',
      inviteEmail: '',
    };
  },
  computed: {
    ...mapState(['invites','members','currentWorkspace', 'userInfoLoaded', 'workspaces', 'userInfo', 'currentUser', 'currentWorkspace', 'isAdmin']),
    logoUrl: function () {
      return this.currentWorkspace.logoUrl;
    },
    allMembers: function () {
      return {...this.invites, ...this.members};
    },
    membersPaginated: function () {
      return this.allMembers && Object.values(this.allMembers).slice((this.currentPage-1)*this.linesPerPage,(this.currentPage-1)*this.linesPerPage+this.linesPerPage);
    },
    totalPages: function () {
      return Object.values(this.allMembers).length/this.linesPerPage;
    }
  },
  methods: {
    saveNewName() {
      if (!this.newTeamName) {
        return (this.error.newTeamName = 'Please fill Name field');
      } else {
        this.error.newTeamName = '';
      }

      this.loading.teamName = true;
      firebaseFirestore
        .collection('workspaces')
        .doc(this.currentWorkspace.id)
        .update({
          name: this.newTeamName
        })
        .then(() => {
          this.loading.teamName = false;
          this.hideFirstModal();
          this.$store.dispatch('action_updateCurrentWorkspace');
        })
        .catch((err) => {
          console.log(err);
        });
    },
    uploadFile(file) {
      if (!file[0]) return;
      this.loading.image = true;
      const filename = AUTH.currentUser.email.replace('.', '-').replace('@', '-');
      let uploadTask = STORAGE.ref('/img/workspace-logo/' + filename).put(file[0], {
        cacheControl: 'public,max-age=31536000',
        contentType: 'image/jpeg'
      });
      uploadTask.on(
        'state_changed',
        () => {},
        null,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((workspaceLogoSrc) => {
            db.collection('workspaces')
              .doc(this.currentWorkspace.id)
              .update({
                logoUrl: workspaceLogoSrc
              })
              .then(() => {
                this.$store.dispatch('action_updateCurrentWorkspace');
                this.loading.image = false;
              });
          });
        }
      );
    },
    sendInvite() {
      if(!this.validateEmail(this.inviteEmail)) {
        return this.error.invite = 'Please enter email';
      }

      if (Object.values(this.invites).find((item) => item.inviteEmail === this.inviteEmail)) {
        return (this.error.invite = 'User already invited');
      } else {
        this.error.invite = '';
      }

      this.loading.invite = true;
      db.collection('invites')
        .add({
          inviteEmail: this.inviteEmail,
          inviterName: this.userInfo.name,
          inviterEmail: this.currentUser.email,
          workspaceName: this.currentWorkspace.name,
          workspaceId: this.currentWorkspace.id
        })
        .then((entry) => {
          ANALYTICS.logEvent('share',{
            inviteEmail: this.inviteEmail,
            inviterEmail: this.currentUser.email,
            workspaceName: this.currentWorkspace.name,
            workspaceId: this.currentWorkspace.id
          });

          this.loading.invite = false;
          this.hideFirstModal();
          this.inviteEmail = '';
          db.collection('workspaces').doc(this.currentWorkspace.id)
            .update({
              invites: firebase.firestore.FieldValue.arrayUnion(entry.id)
            })
            .then(() => {
              this.$store.dispatch('action_updateCurrentWorkspace');
              this.$toasted.show('Invite successfully sent', { type: 'success' });
            });
        });
    },
    userInfoCheck: function () {
      this.subscribeAllWorkspacesMixin()
    },
    currentWorkspaceCheck: function () {
      if (this.isAdmin === false) {
        this.$router.push('/404');
      }
    },
    workspacesCheck: function () {
      this.setCurrentWorkspaceMixin()
    },
    editNameShowPopup: function () {
      this.newTeamName = this.currentWorkspace.name;
      this.activeModal.unshift('changeName');
    },
    clickPaginationHandle: function (pageNum) {
      this.currentPage=pageNum;
    }
  },
  mounted() {
    ANALYTICS.logEvent('page_view');
  }
};
</script>

<style scoped>
html,
body {
  height: 100%;
}
</style>
